<template>
  <div class="assignment-detail">
    <BaseTitle :title="$t('content.assignment_detail')" :yearPeriode="titleData" />
    <v-card class="pa-6 mb-5">
      <header class="d-flex align-center assignment-detail-title">
        <div class="assignment-detail-icon">
          <svg-icon icon="assigment-ic" />
        </div>
        <div>
          <h2 class="app-section-title">{{ datas.assignmentTitle }}</h2>
          <div style="color:#CE8800;">{{ $t('content.by') }}: {{ datas.teacherName }}</div>
        </div>
        <v-spacer />
        <div v-if="type === 'teacher'">
          <template v-if="datas.assignmentType == 4">
            <v-file-input
              :label="$t('form.file')"
              accept=".jpg,.jpeg,.png,.pdf,.mp4,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.mp3"
              chips
              show-size
              small-chips
              truncate-length="15"
              :disabled="datas.submitted"
            ></v-file-input>
          </template>
          <v-spacer />
          <v-btn
            color="primary btn-primary-custom"
            class="mr-2"
            v-if="datas.assignmentTypeId == 1 || datas.assignmentTypeId == 4 || datas.assignmentTypeId == 2"
            @click="goToCurveGrading(datas.assignmentTypeId)"
            :disabled="
              form.students.length === 0 ||
                attempt == true ||
                (scored > 1 && datas.assignmentTypeId == 2) ||
                (scored > 1 && datas.assignmentTypeId == 1)
            "
            >{{ $t('content.curve_grading') }}</v-btn
          >
          <v-btn
            color="primary btn-primary-custom"
            @click="goToScoreFile"
            :disabled="listStudentFile.length === 0"
            v-if="datas.assignmentTypeId == 1"
            >{{ $t('content.scoring') }}</v-btn
          >
          <v-btn color="primary btn-primary-custom" @click="goToScoreQuiz" v-if="datas.assignmentTypeId == 2">{{ $t('content.scoring') }}</v-btn>
        </div>
        <!-- <v-btn color="primary btn-primary-custom" :disabled="datas.submitted">{{ $t(datas.submitted ? 'submitted' : 'submit') }}</v-btn> -->
      </header>
      <div class="assignment-detail-desc">
        <strong>{{ $t('form.desc') }}</strong>
        <article v-if="datas.description" class="container mb-5" v-html="datas.description" />
        <p class="mb-5" v-if="!datas.description">-</p>
        <v-row>
          <v-col md="2">
            <div>
              <span class="d-block">{{ $t('content.file_teacher') }}</span>
              <a href="javascript:(0)" v-if="datas.fileUrl" @click.prevent="previewFileTeacher(undefined, { datas })"
                >{{ datas.fileName }}.{{ datas.extension }}</a
              >
              <strong v-if="!datas.fileUrl">-</strong>
            </div>
          </v-col>
          <v-col md="2">
            <div>
              <span class="d-block">{{ $t('content.available_from') }}</span>
              <strong style="color:#00BF63;" v-if="datas.availableFrom">{{ datas.availableFrom }} {{ datas.availableTime }}</strong>
              <strong style="color:#00BF63;" v-if="!datas.availableFrom">-</strong>
            </div>
          </v-col>
          <v-col md="2">
            <div v-if="datas.lock === false">
              <span class="d-block">{{ $t('content.lock_schedule') }}</span>
              <strong style="color:#E02020;" v-if="datas.availableDate"
                >{{ $t('content.until') }} {{ datas.availableDate }} {{ datas.deadlineTimeStatus }}</strong
              >
              <strong style="color:#E02020;" v-if="!datas.availableDate">-</strong>
            </div>
            <div v-if="datas.lock === true">
              <span class="d-block">{{ $t('content.unlock_schedule') }}</span>
              <strong style="color:#6DD400;" v-if="datas.availableDate"
                >{{ $t('content.until') }} {{ datas.availableDate }} {{ datas.deadlineTimeStatus }}</strong
              >
              <strong style="color:#6DD400;" v-if="!datas.availableDate">-</strong>
            </div>
          </v-col>
          <v-col md="2">
            <div>
              <span class="d-block">{{ $t('content.due_date') }}</span>
              <strong style="color:#FA6400;" v-if="datas.dueDate">{{ datas.dueDate }} {{ datas.deadlineTime }}</strong>
              <strong style="color:#E02020;" v-if="!datas.dueDate">-</strong>
            </div>
          </v-col>
          <v-col md="2">
            <div>
              <span class="d-block">{{ $t('content.assignment_type') }}</span>
              <strong v-if="datas.assignmentTypeId == 4">{{ $t('content.assignment_item.manual_input') }} </strong>
              <strong v-if="datas.assignmentTypeId == 3">{{ $t('content.assignment_item.attendance') }}</strong>
              <strong v-if="datas.assignmentTypeId == 2">{{ $t('content.assignment_item.quiz') }}</strong>
              <strong v-if="datas.assignmentTypeId == 1">{{ $t('content.assignment_item.upload_files') }}</strong>
            </div>
          </v-col>
          <v-col md="2">
            <div>
              <span class="d-block">{{ $t('menu.score') }}</span>
              <strong>{{ datas.totalPoint }} </strong>
            </div>
          </v-col>
        </v-row>
      </div>

      <!-- File Viewer -->
      <file-viewer :data="preview" v-model="dialogPreview" @onHide="hidePreview" />
    </v-card>
    <!-- student List -->
    <v-card class="pa-8 mb-6">
      <div class="d-flex align-items-center justify-space-between">
        <h3 class="app-section-title mb-6">{{ $t('content.student_list') }}</h3>
        <div>
          <v-text-field v-model="search" :label="$t('search')">
            <template #prepend-inner>
              <svg-icon icon="ic-search" class="primary--text mr-3" />
            </template>
          </v-text-field>
        </div>
      </div>
      <v-data-table
        v-if="attempt === false"
        :headers="tableHeader"
        :items="form.students"
        :search="search"
        disable-pagination
        hide-default-footer
        class="table-custom"
      >
        <!-- <template v-slot:item.submittedDateInput="{ item }"> -->
        <!-- <v-btn color="primary" class="btn-primary-custom" v-if="item.newStudent === true" disabled>{{ $t('content.date_time') }}</v-btn>
          <v-btn color="primary" class="btn-primary-custom" v-if="item.newStudent === false" @click="modalDateTime = true">{{
            $t('content.date_time')
          }}</v-btn> -->
        <!-- Dialog Input Date and Time -->
        <template v-slot:item.submittedDateInput="{ item }">
          <!-- <v-btn color="primary" class="btn-primary-custom" v-if="item.newStudent === true" disabled>{{ $t('content.date_time') }}</v-btn> -->
          <v-btn color="primary" class="btn-primary-custom" @click="item.modalDate = true">{{ $t('form.date') }}</v-btn>
          <v-dialog v-model="item.modalDate" persistent max-width="400">
            <v-card>
              <v-card-title class="headline d-flex justify-center">{{ $t('form.date') }} </v-card-title>
              <v-card-text class="d-flex justify-center">
                <form-group :name="$t('form.date')" no-gutter>
                  <template slot-scope="{ attrs }">
                    <v-menu
                      :ref="item.menuDate"
                      v-model="item.menuDate"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="item.menuDate"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template #activator="{ on, attrs:attrActivator }">
                        <v-text-field v-model="item.submittedDateInput" :label="$t('form.date')" v-bind="{ ...attrActivator, ...attrs }" v-on="on">
                          <template #append>
                            <svg-icon icon="calendar" class="primary--text mr-3" />
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="item.submittedDateInput" :locale="$i18n.locale">
                        <v-spacer />
                        <v-btn text color="primary" @click="item.menuDate = false">{{ $t('cancel') }}</v-btn>

                        <v-btn text color="primary" @click="item.menuDate = false">{{ $t('ok') }}</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </template>
                </form-group>
              </v-card-text>
              <v-card-text class="d-flex justify-center">
                <v-btn color="primary" class="btn-primary-custom" @click="item.modalDate = false">
                  {{ $t('close') }}
                </v-btn>
              </v-card-text>
            </v-card>
          </v-dialog>
        </template>

        <!-- </v-card-text> -->
        <!-- <v-card-text class="d-flex justify-center"> -->
        <template v-slot:item.submittedTime="{ item }">
          <v-btn color="primary" class="btn-primary-custom" @click="item.modalTime = true">{{ $t('form.time') }}</v-btn>
          <v-dialog v-model="item.modalTime" persistent max-width="400">
            <v-card>
              <v-card-title class="headline d-flex justify-center">{{ $t('form.time') }} </v-card-title>
              <v-card-text class="d-flex justify-center">
                <form-group :name="$t('form.time')" no-gutter>
                  <template slot-scope="{ attrs }">
                    <v-menu
                      :ref="item.menuTime"
                      v-model="item.menuTime"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="item.menuTime"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs: attrActivator }">
                        <v-text-field v-model="item.submittedTime" :label="$t('form.time')" v-bind="{ ...attrActivator, ...attrs }" v-on="on">
                          <template #append>
                            <svg-icon icon="clock" class="primary--text mr-3" />
                          </template>
                        </v-text-field>
                      </template>
                      <v-time-picker v-model="item.submittedTime" format="24hr" :locale="$i18n.locale" @click:minute="item.menuTime = false" />
                    </v-menu>
                  </template>
                </form-group>
              </v-card-text>
              <v-card-text class="d-flex justify-center">
                <v-btn color="primary" class="btn-primary-custom" @click="item.modalTime = false">
                  {{ $t('close') }}
                </v-btn>
              </v-card-text>
            </v-card>
          </v-dialog>
        </template>

        <!-- </template> -->

        <template v-slot:item.underMinimumPoint="{ item }">
          <span
            v-if="
              (item.underMinimumPoint === false && item.scored === true && item.excused === false) ||
                (item.assignmentTypeId == 3 && item.underMinimumPoint === false && item.scored === false && item.excused === false)
            "
            class="green--text"
            >{{ $t('content.above') }}</span
          >
          <span
            v-if="
              (item.underMinimumPoint === true && item.scored === true && item.excused === false) ||
                (item.assignmentTypeId == 3 && item.underMinimumPoint === true && item.scored === false && item.excused === false)
            "
            class="red--text"
            >{{ $t('content.below') }}</span
          >
          <span
            v-if="
              (item.scored === false && item.assignmentTypeId == 1) ||
                (item.scored === false && item.assignmentTypeId == 2) ||
                (item.scored === false && item.assignmentTypeId == 4) ||
                item.excused === true ||
                !item.assignmentTypeId == 3
            "
            class="red--text"
            >0</span
          >
        </template>
        <template v-slot:item.fullName="{ item }">
          <span
            v-if="datas.assignmentTypeId == 2 || datas.assignmentTypeId == 1"
            @click="popUpData(item)"
            style="
  cursor: pointer;"
            >{{ item.fullName }}</span
          >
          <span v-if="datas.assignmentTypeId == 3 || datas.assignmentTypeId == 4">{{ item.fullName }}</span>
          <span
            v-if="
              (item.newStudent === true && item.assignmentTypeId === 4) ||
                (item.newStudent === true && item.assignmentTypeId === 2) ||
                (item.newStudent === true && item.assignmentTypeId === 1) ||
                (item.newStudent === true && item.assignmentTypeId === 3)
            "
            class="text-caption green--text ml-2"
            style="font-size:5em;"
            >{{ $t('content.new_student') }}</span
          >
          <span
            v-if="
              (item.newStudent === false && !item.submitted && item.assignmentTypeId === 2) ||
                (item.newStudent === false && !item.submitted && item.assignmentTypeId === 1)
            "
            class="text-caption red--text ml-2"
            style="font-size:5em;"
            >{{ $t('content.not_submitted') }}</span
          >
          <span
            v-if="item.newStudent === false && item.attempt && item.assignmentTypeId === 2"
            class="text-caption green--text ml-2"
            style="font-size:5em;"
            >{{ $t('content.attempt') }} {{ item.attempt }}</span
          >
          <!-- <span v-if="item.assignmentTypeId !== 2 && item.newStudent === false">{{ item.fullName }}</span> -->
        </template>
        <template v-slot:item.submittedDate="{ item }">
          <span v-if="item.submittedDate">{{ item.submittedDate }}</span>
          <span v-else>-</span>
        </template>
        <template #item.score="{ item }">
          <v-text-field
            v-model="item.score"
            type="number"
            min="0"
            oninput="if(Number(this.value) > Number(100)) this.value = 100;"
            v-if="datas.assignmentTypeId === 3 && item.excused === false"
            :disabled="type === 'school-advisor'"
            v-number
          />

          <v-text-field
            v-model="item.score"
            v-if="datas.assignmentTypeId !== 3 && item.excused === false"
            :disabled="type === 'school-advisor'"
            min="0"
            v-number
            @input="maximum({ $event, item, idx: form.students.indexOf(item) })"
            type="number"
          />
          <!-- 
            :disabled="datas.published === true || (!item.submitted && item.assignmentTypeId === 2)" -->
          <span v-if="item.excused === true">-</span>
        </template>
        <template v-slot:item.late="{ item }">
          <v-simple-checkbox
            v-model="item.late"
            :disabled="datas.published === true || (!item.submitted && item.assignmentTypeId === 2) || type === 'school-advisor'"
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.excused="{ item }">
          <v-simple-checkbox v-model="item.excused" :disabled="type === 'school-advisor'" />
        </template>

        <!-- :disabled="item.newStudent === true || (!item.attempt && item.assignmentTypeId === 2)" -->
        <template #no-data>{{ $t('data_not_available') }}</template>
      </v-data-table>
      <v-data-table
        v-if="attempt === true"
        :headers="tableHeaderAttempt"
        :items="form.students"
        :search="search"
        disable-pagination
        hide-default-footer
        class="table-custom"
      >
        <template v-slot:item.ready="{ item }">
          <span v-if="item.ready === false">{{ $t('content.not_scored') }}</span>
        </template>
        <template #no-data>{{ $t('data_not_available') }}</template>
      </v-data-table>
      <!-- Dialog Student -->
      <v-dialog v-model="attemptPop" persistent max-width="1000">
        <v-card class="pa-6">
          <div class="d-flex align-center justify-space-between">
            <h3 class="app-section-title mb-6">{{ $t('content.attempt_list') }}</h3>
            <div>
              <v-text-field v-model="searchAttempt" :label="$t('search')">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
          </div>
          <v-data-table
            :headers="tableHeaderAttemptDetail"
            :loading="loading"
            :items="attemptDetail"
            hide-default-footer
            class="table-custom scroll"
            :search="searchAttempt"
            disable-pagination
          >
            <template #item.attempt="{ item }">
              <span>{{ $t('content.attempt') }} {{ item.attempt }}</span>
            </template>
            <template #item.complete="{ item }">
              <strong v-if="item.complete" class="green--text font-italic">{{ $t('content.complete') }}</strong>
              <strong v-else class="red--text font-italic">{{ $t('content.incomplete') }}</strong>
            </template>

            <template #item.actions="{ item }">
              <v-btn text @click="deleteAttempt(item)" class="mr-1 btn-action-custom">
                <svg-icon icon="delete" class="red--text" />
              </v-btn>
            </template>
            <template #no-data><NoData /></template>
          </v-data-table>
          <div class="d-flex justify-end align-center mt-4">
            <v-btn color="primary" class="btn-primary-custom" outlined @click="attemptPop = false">{{ $t('close') }}</v-btn>
          </div>
        </v-card>
      </v-dialog>
    </v-card>
    <div class="d-flex justify-start align-center" v-if="type === 'teacher'">
      <v-checkbox v-model="datas.detailPublish" :label="$t('content.detail_scores_dipslay')"></v-checkbox>
    </div>
    <!-- Button Controls -->
    <div class="d-flex justify-end align-center pa-4">
      <v-btn color="primary" class="btn-primary-custom mr-2" outlined @click="back">{{ $t('back') }}</v-btn>
      <v-btn
        v-if="type === 'teacher'"
        color="primary"
        class="btn-primary-custom"
        :disabled="disebelBut === true"
        @click="submitStudent"
        :loading="loadingStudent"
        type="submit"
        >{{ $t('save') }}</v-btn
      >
      <v-btn
        v-if="type === 'teacher'"
        color="primary"
        class="btn-primary-custom ml-10"
        :disabled="disebelBut === true"
        @click="submitPublish(datas.assignmentId)"
        :loading="loading"
        type="submit"
      >
        {{ $t(datas.published ? 'content.unpublish_score' : 'content.publish_score') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import ripple from 'vuetify/lib/directives/ripple';
import FileViewer from '@/components/FileViewer';
import NoData from '@/components/table/NoData';

export default {
  name: 'AssignmentDetail',
  directives: {
    ripple
  },
  components: {
    BaseTitle,
    FileViewer,
    NoData
  },
  props: {
    type: {
      type: String
    }
  },
  computed: {
    ...mapGetters({
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    }),
    tableHeader() {
      if (this.datas.assignmentTypeId !== 3 && this.datas.assignmentTypeId !== 4 && this.datas.assignmentTypeId !== 1) {
        return [
          { text: this.$t('table.name'), value: 'fullName', sortable: false },
          { text: this.$t('content.submitted_date'), value: 'submittedDate', sortable: false },
          { text: this.$t('content.score'), value: 'score', sortable: false, width: 100 },
          { text: this.$t('content.attendance_item.late'), value: 'late', sortable: false },
          { text: this.$t('content.under_minumum'), value: 'underMinimumPoint', sortable: false },
          { text: this.$t('content.excused'), value: 'excused', sortable: false }
        ];
      } else if (this.datas.assignmentTypeId === 3) {
        return [
          { text: this.$t('table.name'), value: 'fullName', sortable: false },
          { text: this.$t('content.attendance_title'), value: 'score', sortable: false, width: 100 },
          { text: this.$t('content.under_minumum'), value: 'underMinimumPoint', sortable: false, width: 100 },
          { text: this.$t('content.excused'), value: 'excused', sortable: false }
        ];
      } else if (this.datas.assignmentTypeId === 4) {
        return [
          { text: this.$t('table.name'), value: 'fullName', sortable: false },
          { text: this.$t('form.date'), value: 'submittedDateInput' },
          { text: this.$t('form.time'), value: 'submittedTime' },
          { text: this.$t('content.score'), value: 'score', sortable: false, width: 100 },
          { text: this.$t('content.attendance_item.late'), value: 'late', sortable: false },
          { text: this.$t('content.under_minumum'), value: 'underMinimumPoint', sortable: false },
          { text: this.$t('content.excused'), value: 'excused', sortable: false }
        ];
      } else {
        return [
          { text: this.$t('table.name'), value: 'fullName', sortable: false },
          { text: this.$t('content.submitted_date'), value: 'submittedDate', sortable: false },
          { text: this.$t('content.score'), value: 'score', sortable: false, width: 100 },
          { text: this.$t('content.attendance_item.late'), value: 'late', sortable: false },
          { text: this.$t('content.under_minumum'), value: 'underMinimumPoint', sortable: false },
          { text: this.$t('content.excused'), value: 'excused', sortable: false }
        ];
      }
    },
    tableHeaderAttempt() {
      return [
        { text: this.$t('table.name'), value: 'fullName', sortable: false },
        { text: this.$t('information'), value: 'ready', sortable: false }
      ];
    },
    tableHeaderAttemptDetail() {
      return [
        { text: this.$t('content.attempt'), value: 'attempt' },
        { text: this.$t('menu.score'), value: 'totalScore' },
        { text: this.$t('form.status'), value: 'complete' },
        { text: this.$t('table.action'), value: 'actions', sortable: false, width: 200 }
      ];
    }
  },
  data: () => ({
    menuAvailable: false,
    modalDateTime: false,
    menuDate: false,
    menuTime: false,
    attemptPop: false,
    searchAttempt: '',
    dataClass: '',
    id: null,
    listStudentFile: [],
    student: [],
    attempt: true,
    form: {
      students: []
    },
    loading: false,
    loadingStudent: false,
    search: '',
    datas: {},
    dialogPreview: false,
    preview: {},
    disebelBut: false,
    scored: '',
    attemptDetail: [],
    temporaryStudent: '',
    titleData: ''
  }),
  methods: {
    deleteAttempt(item) {
      this.$store
        .dispatch('Assignment/deleteAttemptDetail', {
          quizAssignmentStudentId: item.quizAssignmentStudentId,
          studentId: this.temporaryStudent.studentId,
          assignmentId: this.temporaryStudent.assignmentId
        })
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.getDetailAttempt({
            quizAssignmentStudentId: item.quizAssignmentStudentId,
            studentId: this.temporaryStudent.studentId,
            assignmentId: this.temporaryStudent.assignmentId
          });
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    popUpData(item) {
      this.temporaryStudent = item;
      this.attemptPop = true;
      this.loading = true;
      this.getDetailAttempt(item);
    },
    getDetailAttempt(item) {
      this.$store
        .dispatch('Assignment/fetchAttemptDetail', { assignmentId: item.assignmentId, studentId: item.studentId })
        .then(res => {
          this.attemptDetail = res;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loading = false));
    },
    maximum(e) {
      if (Number(e.$event) > Number(e.item.outOf)) {
        this.$nextTick(() => {
          this.form.students[e.idx].score = e.item.outOf;
        });
      }
    },
    closeModal() {
      this.modalDateTime = false;
    },
    nameKeydown(e) {
      if (/^\W$/.test(e.key)) {
        e.preventDefault();
      }
    },
    // File Viewer Teacher
    previewFileTeacher(e, { datas }) {
      this.dialogPreview = true;
      this.$set(this, 'preview', datas);
    },
    hidePreview() {
      this.dialogPreview = null;
      this.$set(this, 'preview', {});
    },
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    getData(id) {
      this.$store
        .dispatch('Assignment/fetchDetail', id)
        .then(res => {
          this.datas = res;
          this.id = res.id;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    getStudent() {
      this.$store
        .dispatch('Assignment/fetchStudent', this.$route.params.assignmentId)
        .then(res => {
          // console.info(res);
          if (res.length >= 1) {
            this.disebelBut = false;
            this.attempt = false;
            var scored = res.filter(data => data.scored === false);
            this.scored = scored.length;
            this.form.students = res;
          } else {
            this.disebelBut = true;
            this.attempt = true;
            this.getStudentAttempt();
          }
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    getStudentAttempt() {
      this.$store
        .dispatch('Assignment/fetchStudentListAttempt', this.$route.params.assignmentId)
        .then(res => {
          res.forEach(form => (form.ready = false));
          this.form.students = res;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    submitStudent() {
      var assignmentId = this.$route.params.assignmentId;
      this.loadingStudent = true;
      this.$store
        .dispatch(`Assignment/updateStudent`, { ...this.form, assignmentId })
        .then(() => {
          this.$store.dispatch('general/showSuccessNotification', { message: this.$t('alert.save_student_list') });
          this.getStudent();
          var detailPublished = this.datas.detailPublish;
          this.loading = true;
          this.$store
            .dispatch(`Assignment/updatePublish`, { assignmentId, published: this.datas.published, detailPublished })
            .then(() => {
              this.getStudent();
              this.getData(this.$route.params.assignmentId);
            })
            .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
            .finally(() => (this.loading = false));
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loadingStudent = false));
    },
    submitPublish(assignmentId) {
      var detailPublished = this.datas.detailPublish;
      if (this.datas.published === true) {
        this.loading = true;
        this.$store
          .dispatch(`Assignment/updatePublish`, { assignmentId, published: false, detailPublished })
          .then(() => {
            this.$store.dispatch('general/showSuccessNotification', { message: this.$t('alert.save_publish') });
            this.getStudent();
            this.getData(this.$route.params.assignmentId);
          })
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
          .finally(() => (this.loading = false));
      } else {
        this.loading = true;
        this.$store
          .dispatch(`Assignment/updatePublish`, { assignmentId, published: true, detailPublished })
          .then(() => {
            this.$store.dispatch('general/showSuccessNotification', { message: this.$t('alert.save_unpublish') });
            this.getStudent();
            this.getData(this.$route.params.assignmentId);
          })
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
          .finally(() => (this.loading = false));
      }
    },
    getStudentFile() {
      var assignmentId = this.$route.params.assignmentId;
      this.$store
        .dispatch('Assignment/fetchListFile', { assignmentId })
        .then(res => {
          this.listStudentFile = res;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    getItem(key, defaultValue) {
      return this.item?.[key] ?? defaultValue;
    },
    goToScoreFile() {
      if (!this.$route.params.classSectionId) {
        this.$router.push({ name: 'TeacherAssignmentScoreFile' });
      } else {
        this.$router.push({ name: 'TeacherAssignmentSectionScoreFile' });
      }
    },
    goToCurveGrading(assignmentTypeId) {
      localStorage.setItem('assignmentTypeId', assignmentTypeId);
      if (!this.$route.params.classSectionId) {
        this.$router.push({ name: 'TeacherAssignmentCurveGrading' });
      } else {
        this.$router.push({ name: 'TeacherAssignmentSectionCurveGrading' });
      }
    },
    goToScoreQuiz() {
      if (!this.$route.params.classSectionId) {
        this.$router.push({ name: 'TeacherAssignmentQuizAttempt' });
      } else {
        this.$router.push({ name: 'TeacherAssignmentSectionQuizAttempt' });
      }
    },
    back() {
      var backModules = localStorage.getItem('backModules');
      if (backModules) {
        this.$router.back();
      } else {
        if (this.type === 'teacher') {
          if (!this.$route.params.classSectionId) {
            this.$router.push({ name: 'TeacherAssignment' });
          } else {
            this.$router.push({ name: 'TeacherAssignmentSection' });
          }
        } else {
          if (!this.$route.params.classSectionId) {
            this.$router.push({ name: 'AdvisorAssignment' });
          } else {
            this.$router.push({ name: 'AdvisorSectionAssignment' });
          }
        }
      }
    }
  },
  created() {
    this.getDataClass();
    if (this.$route.params.assignmentId) {
      this.getData(this.$route.params.assignmentId);
      this.getStudentFile();
      this.getStudent();
    }
  }
};
</script>

<style lang="scss" scoped>
.assignment-detail {
  &-title {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #dedede;
  }

  &-icon {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    background: #fff0da;
    color: #f1b65a;
    box-sizing: border-box;
    text-align: center;
    margin-right: 16px;

    svg {
      transform: scale(1.6);
      margin-top: 15px;
    }
  }

  &-desc {
    line-height: 1.8em;
    padding-left: 65px;
  }
}
</style>
